<template>
  <div>
    <PlannerHeader id="goal-list-header" @click="handleCreateNewGoal">goals</PlannerHeader>
    <FilterOptions v-model="filter" :filterOptions="filterOptions" class="mb-4"/>

    <div v-if="loading">
      <Loader/>
    </div>

    <div v-else>
      <div v-if="nothingToShow">

        <EmptyState title="Keep track of your progress." subtitle="Turn your invisible dreams into visible ones. Write down a plan towards your dreams and put them into action." subtitle2="What monthly or quarterly goal will make you jump out of bed in the morning?">
            <div class="mt-4">
              <vs-button class="w-1/2 m-1" @click.stop="handleCreateNewGoal({})" >
                create goal
              </vs-button>
              </div>

              <div>
               <vs-button class="w-1/2 m-1 track-goal-get-inspired" type="border" @click.stop="handleGetInspired">
                get inspired
              </vs-button>
            </div>
        </EmptyState>

      </div>

      <div v-else>

        <div v-if="overdueGoals.length > 0" class="mb-10">
          <TasksDivider title="overdue" :count="overdueGoals.length" :hideAdd="true"/>
          <transition-group name="list">
            <template v-for="goal in overdueGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>


        <div v-if="thisMonthGoals.length > 0" class="mb-10">
          <TasksDivider title="this month" :count="thisMonthGoals.length" @addCallback="addNewGoalThisMonth"/>
          <transition-group name="list">
            <template v-for="goal in thisMonthGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>

        <div v-if="nextMonthGoals.length > 0" class="mb-10">
          <TasksDivider title="next month" :count="nextMonthGoals.length" @addCallback="addNewGoalNextMonth"/>
          <transition-group name="list">
            <template v-for="goal in nextMonthGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>

        <div v-if="soonGoals.length > 0" class="mb-10">
          <TasksDivider title="soon" :hideAdd="true" :count="soonGoals.length"/>
          <transition-group name="list">
            <template v-for="goal in soonGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>

        <div v-visible="somedayGoals.length > 0" class="mb-10">
          <TasksDivider title="someday" :hideAdd="true" :count="somedayGoals.length"/>
          <transition-group name="list">
            <template v-for="goal in somedayGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>

        <div v-if="allSection">
          <TasksDivider v-if="pausedGoals.length > 0" title="paused" :hideAdd="true" :count="pausedGoals.length"/>
          <transition-group name="list">
            <template v-for="goal in pausedGoals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="true"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
            </template>
          </transition-group>
        </div>


        <!-- </div> -->
      </div>
    </div>

    <GoalSidebar
      :initValue="sidebarActive"
      :editedEntity="editedEntity"
      :showSection="prefferedSection"
      @close="sidebarActive=false"
    />

  </div>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import AddNew from './AddNew'
import SelectButton from './SelectButton'
import EditForm from './EditForm'
import Select from './Select'
import AssignGoals from './AssignGoals'
import AddDropdown from './AddDropdown'
import GoalSidebar from './GoalSidebar'
import Goal from './Goal'
import GoalsPreviewPlanner from '../Preview/GoalsPreviewPlanner'
import NoGoalsInDream from '../Preview/NoGoalsInDream'
import PeriodToggle from '../Generic/PeriodToggle'
import ListDivider from '../Generic/ListDivider'
import trackAnalytics from '@/helpers/trackAnalytics'
import FilterOptions from '../Generic/FilterOptions'
import Sidebar from '@/views/Self-Improvee/Generic/Sidebar'
import PlannerHeader from '../Planner/PlannerHeader'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
    draggable,
    AddNew,
    SelectButton,
    EditForm,
    Select,
    Goal,
    GoalsPreviewPlanner,
    PeriodToggle,
    AssignGoals,
    AddDropdown,
    NoGoalsInDream,
    ListDivider,
    FilterOptions,
    Sidebar,
    PlannerHeader,
    GoalSidebar
  },
  props: {
    planningMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dreamMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dream: {
      type: Object,
      required: false,
      default: () => null
    },
    initWithGoalSidebarOpen: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    period: {
      type: Date,
      required: false,
      default: () => null,
    }
  },
  data () {
    return {
      sidebarActive: false,
      editedEntity: {},
      overdueGoals: [],
      thisMonthGoals: [],
      soonGoals: [],
      somedayGoals: [],
      notPlannedGoals: [],
      plannedGoals: [],
      pausedGoals: [],
      loading: true,
      goalsOrder: {},
      selecting: false,
      filter: this.$store.getters.goalsListFilter || 'all',
      prefferedSection: null,
      filterOptions: ['active', 'all'],
    }
  },
  watch: {
    '$store.getters.inProgressGoals': {
      immediate: false,
      handler () {
        this.loadGoals()
      }
    },
    'initWithGoalSidebarOpen': {
      immediate: true,
      handler (initWithGoalSidebarOpen) {
        if (initWithGoalSidebarOpen) {
          setTimeout(
            () => { this.sidebarActive = true },
            1000
          )
        }
      }
    },
    'filter': {
      immediate: true,
      handler (filter) {
        if (filter) {
          this.$store.commit('SET_GOALS_LIST_FILTER', { filter: this.filter })
        }
        this.loadGoals()
      }
    },
    '$store.getters.filter': {
      immediate: false,
      handler (filter) {
        this.loadGoals()
      }
    },
  },
  computed: {
    allSection () {
      return _.includes(this.filter, 'all')
    },
    nothingToShow () {
      return this.overdueGoals.length + this.thisMonthGoals.length + this.nextMonthGoals.length + this.soonGoals.length + this.somedayGoals.length + this.pausedGoals.length < 1
    },
  },
  mounted () {
    this.$store.dispatch('bindGoals').then(() => {
      // this.loadGoals()
      this.loading = false
    })
  },
  methods: {
    async loadGoals () {
      // this.loading = true


      this.overdueGoals =  this.filterGoals(_.sortBy(this.$store.getters.overdueGoals, (goal) => goal.deadline.toDate()))
      this.thisMonthGoals =  this.filterGoals(_.sortBy(this.$store.getters.thisMonthGoals, (goal) => goal.deadline.toDate()))
      this.nextMonthGoals =  this.filterGoals(_.sortBy(this.$store.getters.nextMonthGoals, (goal) => goal.deadline.toDate()))
      this.soonGoals =  this.filterGoals(_.sortBy(this.$store.getters.soonGoals, (goal) => goal.deadline.toDate()))

      this.somedayGoals = this.filterGoals(this.keepOrderBy(this.somedayGoals,
        this.$store.getters.somedayGoals)
      )

      this.pausedGoals = this.filterGoals(this.keepOrderBy(this.pausedGoals,
        this.$store.getters.pausedGoals)
      )

      // setTimeout(() => { this.loading = false }, 500)
    },
    filterGoals (goals) {
      if (_.get(this.$store.getters.filter, 'color')) {
        return _.filter(goals, (goal) => goal.backgroundColor === this.$store.getters.filter.color)
      } else {
        return goals
      }
    },
    keepOrderBy (originalArray, newArray) {
      return _.sortBy(
        newArray, (goal) => _.findIndex(originalArray, (g) => g.id === goal.id)
      )
    },
    addNewGoalThisMonth () {
      this.handleCreateNewGoal({ deadline: DateHelper.endOfMonth() })
    },
    addNewGoalNextMonth () {
      this.handleCreateNewGoal({ deadline: DateHelper.endOfNextMonth() })
    },
    addGoalDialog () {
      this.editedEntity = {
        dreamId: _.get(this.dream, 'id')
      }
    },
    toggleGoalsCollapsed () {
      this.$store.commit('SET_GOALS_COLLAPSED', !this.goalsCollapsed)
    },
    handleCreateNewGoal (params = {}) {
      this.prefferedSection = null
      this.editedEntity = params
      this.sidebarActive = true
    },
    handleGetInspired () {
      this.prefferedSection = 'get inspired'
      this.editedEntity = {}
      this.sidebarActive = true
    },
    editGoalDialog (goal) {
      this.editedEntity = goal
      this.sidebarActive = true
    },
    closeGoalDialog () {
      this.editedEntity = null
    },
    updateGoalsOrder (goals) {
      if (this.dreamMode) return

      _.each(goals, async (goal, order) => {
        const orderKey = this.goalsOrderKey
        await this.$store.dispatch('UPDATE_GOAL_ORDER', { goal, order, orderKey })
      })
      trackAnalytics(this, 'app_action', 'change_goal_order', null, this.$store.getters.daysFromRegistration)
    }
  }
}
</script>
<style>
  .vs-slider {
    height: 6px;
  }
  .vs-slider--circle {
    top: -8px;
    width: 20px;
    height: 20px;
  }

  .ghost-goal {
    opacity: 0.2;
  }
  .handle {
    cursor: move;
  }

  .vs-popup--header {
    background: #ffffff
  }

  .vs-popup--title h3 {
    font-size: 1.5rem;
  }

  .add-dropdown__menu {
    font-size: 1.3rem;
  }

</style>
